import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "./api";
import ReviewEditControls from "./ReviewEditControls";
import StatusBadge, { LLM_TONE } from "@/components/brand/StatusBadge";
import { Time } from "./time";

// "My recent reviews": my last 200 labels, newest first, searchable; edit / change / undo per row.
export default function MyReviews({ styles }) {
  const [q, setQ] = useState("");
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  const [open, setOpen] = useState(null);
  const load = useCallback(() => api.myReviews(q).then((r) => { setData(r.data); setErr(""); }).catch((ex) => setErr(ex.message)), [q]);
  useEffect(() => { load(); }, [load]);
  return (
    <div data-testid="my-reviews">
      <div style={styles.row}>
        <label className="hs-label" htmlFor="my-reviews-q" style={{ marginBottom: 0 }}>Search</label>
        <input id="my-reviews-q" data-testid="my-reviews-search" style={{ ...styles.input, minWidth: 260 }} value={q}
               placeholder="item or note" onChange={(e) => setQ(e.target.value)} />
        {data && <span style={{ fontSize: 12, color: "var(--hs-text-muted)" }}>{data.count} label(s) by {data.actor}</span>}
      </div>
      {err && <div className="hs-text-danger">{err}</div>}
      <div style={styles.card}>
        <table style={styles.tbl}>
          <thead><tr><th style={styles.th}>When</th><th style={styles.th}>Item</th><th style={styles.th}>Label</th>
            <th style={styles.th}>Note</th><th style={styles.th}>State</th><th style={styles.th}></th></tr></thead>
          <tbody>{(data?.reviews || []).map((r) => (
            <React.Fragment key={r.verdict_id}>
              <tr data-testid={`my-review-${r.verdict_id}`}>
                <td style={styles.td}><Time value={r.created_at} /></td>
                <td style={{ ...styles.td, fontFamily: "var(--hs-font-mono)" }}>
                  <Link className="hs-link" to={`/admin/items/${r.item_id}`}>{r.item.registry_name || r.item.display_name || r.item.identifier}</Link>
                </td>
                <td style={styles.td}><StatusBadge tone={LLM_TONE[r.label] || "neutral"}>{r.label}</StatusBadge></td>
                <td style={{ ...styles.td, whiteSpace: "pre-wrap", maxWidth: 360 }}>{r.note || "—"}</td>
                <td style={styles.td}>{r.state}{!r.on_current_snapshot && r.state === "active" && <div style={{ fontSize: 12, color: "var(--hs-text-muted)" }}>content changed since</div>}</td>
                <td style={styles.td}>{r.state === "active" && (
                  <button type="button" style={styles.btnDim} data-testid={`my-review-edit-${r.verdict_id}`}
                          onClick={() => setOpen(open === r.verdict_id ? null : r.verdict_id)}>{open === r.verdict_id ? "Close" : "Edit"}</button>)}</td>
              </tr>
              {open === r.verdict_id && (
                <tr><td colSpan={6} style={styles.td}><ReviewEditControls verdict={r} styles={styles} onChanged={() => { setOpen(null); load(); }} /></td></tr>)}
            </React.Fragment>))}
          {data && data.reviews.length === 0 && <tr><td style={styles.td} colSpan={6}>No labels yet.</td></tr>}</tbody>
        </table>
      </div>
    </div>
  );
}
